// extracted by mini-css-extract-plugin
export default {"cardsList":"EmployeeCardsList_cardsList__nJEOo","cardsListTitle":"EmployeeCardsList_cardsListTitle__DL1YZ"};